<template>
  <div class="page" :class="[scrollContent ? 'scroll-content' : '']">    
    <PageLeft>
    <template v-slot:page>
        <div ref="content">        
            <div class="all-content">    
                <div class="image"><transition name="fade" mode="out-in" appear><img src="@/assets/images/las_vegas_market/bg_las-vegas-market_las-vegas.jpg" alt=""></transition></div>                        
                  <div class="page-content content">
                    <transition name="slide-fade" mode="out-in" appear>
                      <TitleContent h2="Las Vegas Market" h1="Las Vegas" />
                    </transition>
                    <transition name="slide-fade" mode="out-in" appear>
                      <div class="text-content">                      
                        <p class='large yellow'>The Entertainment Capital of the world.</p>
                        <p>In a city built for nightlife, the arrival of Allegiant Stadium creates an incredible growth opportunity for the entertainment landscape of Las Vegas. The stadium’s prominent location creates a seamless event experience for guests, including a unique opportunity to avoid traffic and walk to the event from the Strip via Hacienda Bridge.</p>
                        <Stats :stats="[                                                        
                            {label:'Local Population', value:'2.4', suffix:'M'},
                          ]" 
                        />
                        <LasVegas :data="metrics" />                                                
                      </div>                    
                    </transition>
                  </div>                
            </div>
        </div>
    </template>
    </PageLeft>    
  </div>
</template>

<script>
import Stats from "@/components/Stats.vue";
import PageLeft from "@/patterns/PageLeft.vue";
import TitleContent from "@/patterns/TitleContent.vue";
import LasVegas from "@/components/LasVegas.vue";
export default {
  name: "TheStadium",
  components: { LasVegas, PageLeft, TitleContent, Stats },
  data: () => ({
    scrollContent: false, 
    metrics : [
      [
        'Race', 'White: 42%', 'Hispanic: 32%', 'Black: 13%', 'Asian: 10%', 'Other: 3%'
      ],
      [
        'Age', 'Under 20: 25%', '20-39: 28%', '40-59: 26%', '60 and up: 21%'
      ], 
      [
        'Gender', 'Female: 50%', 'Male: 50%'
      ]
    ]
    /*
    metrics: [
      {
        race:'White: 42%',
        age:'Under 20: 25%',
        gender:'Female: 50%',
        income:'Median Household Income: $60,000'
      },
      {
        race:'Black: 13%',
        age:'20-39: 28%',
        gender:'Male: 50%',
        income:'Average Home Value: $313,000'
      },
      {
        race:'Hispanic: 32%',
        age:'40-59: 26%',
        gender:'',
        income:'National Average: $276,000'
      },
      {
        race:'Asian: 10%',
        age:'60 and Up: 21%',
        gender:'',
        income:''
      },
      {
        race:'Other 3%',
        age:'',
        gender:'',
        income:''
      },
    ]   
    */
  }),  
  mounted() {
    window.addEventListener("resize", this.shouldScrollContent);
  },
  beforeDestroy: function () {
    window.removeEventListener("resize", this.shouldScrollContent);
  },
  methods: {
    shouldScrollContent() {
      this.scrollContent =
        this.$refs.content.clientHeight > window.innerHeight ? true : false;
    },
  },
};
</script>
<style lang="scss">

</style>